import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { invoke } from '../../utils/invoke';
import { FocusSource } from '../../types';
export function FocusObserver(_ref) {
  var onFocus = _ref.onFocus,
    children = _ref.children;
  var childProps = children.props;
  var handleFocus = function handleFocus() {
    onFocus(true, FocusSource.keyboard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    invoke.apply(void 0, [childProps.onFocus].concat(args));
  };
  var handleBlur = function handleBlur() {
    onFocus(false);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    invoke.apply(void 0, [childProps.onBlur].concat(args));
  };
  var handleClick = function handleClick() {
    onFocus(true, FocusSource.mouse);
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    invoke.apply(void 0, [childProps.onClick].concat(args));
  };
  var handleMouseDown = function handleMouseDown() {
    onFocus(true, FocusSource.mouse);
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    invoke.apply(void 0, [childProps.onMouseDown].concat(args));
  };
  return /*#__PURE__*/React.cloneElement(children, _objectSpread(_objectSpread({}, children.props), {}, {
    onFocus: handleFocus,
    onBlur: handleBlur,
    onClick: handleClick,
    onMouseDown: handleMouseDown
  }));
}